var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5B48A2"
    },
    cx: 148.5,
    cy: 148.5,
    r: 148.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3287"
    },
    d: "M295.007,172.816L194.021,71.83c-31.568,28.496-65.012,55.146-96.521,85.67 c-13.129,13.129-28.28,25.58-44.344,35.705L156.721,296.77C226.74,292.949,283.836,240.625,295.007,172.816z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82D9C8"
    },
    d: "M217.08,210.899c24.844,0,44.984-20.14,44.984-44.984s-20.14-44.984-44.984-44.984 c-1.306,0-2.595,0.068-3.873,0.177c0.043-0.972,0.075-1.947,0.074-2.93c-0.033-36.112-29.319-65.397-65.411-65.411 c-30.769-0.012-56.561,21.25-63.538,49.871c-25.806,4.304-45.481,26.724-45.481,53.751c0,30.105,24.405,54.509,54.509,54.509 L217.08,210.899L217.08,210.899z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BCAB"
    },
    d: "M217.08,120.931c-1.306,0-2.595,0.068-3.873,0.177c0.043-0.972,0.074-1.947,0.074-2.93 c-0.003-36.082-29.288-65.367-65.411-65.411c-0.124,0-0.246,0.007-0.37,0.008v158.124h69.58c24.844,0,44.984-20.14,44.984-44.984 S241.924,120.931,217.08,120.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34495E"
    },
    d: "M132.36,111.732l49.211,28.412c4.62,2.668,4.62,9.337,0,12.004L132.36,180.56 c-4.62,2.668-10.396-0.667-10.396-6.002v-56.824C121.964,112.399,127.739,109.065,132.36,111.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20313F"
    },
    d: "M181.571,140.145L147.5,120.474v51.346l34.071-19.671 C186.192,149.481,186.192,142.812,181.571,140.145z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.3f26db08e4be7dbf73f14a5a2031c572.svg";
export { ForwardRef as ReactComponent };